import { createSlice } from '@reduxjs/toolkit';

interface WhatsappSlice {
  profile: {
    id: string;
    verifiedName?: string;
    phoneNumber?: string;
    email?: string;
    channel?: { name: string; id: string };
    phoneNumberId?: string;
    wabaId?: string;
    channelId?: string;
    address?: string;
    description?: string;
    vertical?: string;
    about?: string;
    websites?: string;
    profilePicture?: string;
    config?: object;
    rawFile?: string;
    isConnectedCatalog?: boolean;
    catalog?: {
      name: string;
      id: string;
    };
    isUseMMLite?: boolean;
  };
  template: {
    name: string;
    header: {
      type: 'TEXT' | 'VIDEO' | 'IMAGE' | 'DOCUMENT' | '';
      text: string;
      name: string;
      format: string;
      content: { preview: unknown; fileName?: ''; rawFile?: unknown };
    };
    body: string;
    buttonType: 'URL' | 'QUICK_REPLY' | '';
    buttons: Array<{ text: string; type: string; url?: string }>;
    language: string;
    footer: string;
    category: 'MARKETING' | 'OTP' | 'UTILITY' | '';
  };
}

const initialState: WhatsappSlice = {
  profile: {
    id: '',
  },
  template: {
    name: '',
    header: {
      type: '',
      text: '',
      name: '',
      format: '',
      content: { preview: '' },
    },
    body: '',
    buttonType: '',
    buttons: [],
    language: 'id',
    footer: '',
    category: 'MARKETING',
  },
};

export const whatsappSlice = createSlice({
  name: 'whatsapp',
  initialState,
  reducers: {
    selectTemplate: (state, { payload }) => {
      state.template = { ...payload, header: {} };
    },
    resetTemplate: (state) => {
      state.template = initialState.template;
    },
    setTemplate: (state, action) => {
      state.template = action.payload;
    },
    setChannelWa: (state, action) => {
      state.profile = action.payload;
    },
    removeChannelWa: (state) => {
      state.profile = { id: '' };
    },
  },
});

export const {
  setChannelWa,
  removeChannelWa,
  setTemplate,
  resetTemplate,
  selectTemplate,
} = whatsappSlice.actions;

export default whatsappSlice.reducer;
